import { Route, Routes, useLocation } from '@solidjs/router';
import { createSignal, lazy, onMount, Show } from 'solid-js';
import { FullScreenLayout } from '~/components/layouts';
import { auth } from '~/config/auth';
import { AuthProvider } from '~/contexts/global';
import type { ParentComponent } from 'solid-js';

const SignInPage = lazy(() => import('~/pages/auth/SignIn'));
const ResetPasswordPage = lazy(() => import('~/pages/auth/ResetPassword'));
const MagicLinkPage = lazy(() => import('~/pages/auth/MagicLink'));
const CallbackPage = lazy(() => import('~/pages/auth/Callback'));

export const AuthGuard: ParentComponent = (props) => {
  const [isAuthenticated, setIsAuthenticated] = createSignal(false);
  const location = useLocation();

  const checkAuth = async () => {
    if (location.pathname.startsWith('/auth')) return;
    await auth.getAccessToken();
    setIsAuthenticated(true);
  };

  onMount(() => {
    checkAuth();
  });

  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth" component={FullScreenLayout}>
          <Route path="signin" component={SignInPage} />
          <Route path="reset-password" component={ResetPasswordPage} />
          <Route path="magic-link" component={MagicLinkPage} />
          <Route path="callback" component={CallbackPage} />
        </Route>
      </Routes>
      <Show when={isAuthenticated()}>{props.children}</Show>
    </AuthProvider>
  );
};
